module.exports = __webpack_public_path__ + "media/images/icons/country_flags/az-ffc79bfa06e3b01520e0d39df12fcb8e.svg";